import React from "react";
import PropTypes from "prop-types";
import { Collapse } from "react-bootstrap";
import { MdKeyboardArrowUp } from "react-icons/md";
import "./CollapsibleTabs.scss";
import Scrollbars from "components/Scrollbars/Scrollbars";

const renderTab = ({
  label,
  color = "",
  value,
  count,
  active,
  content,
  onChange,
  className = "",
  noScroll = false,
}) => {
  const isActiveCls = active ? "active" : "";
  const noScrollCls = noScroll ? "no-scroll" : "";
  const onTabClick = (tab) => {
    onChange(tab);
  };
  return (
    <div
      className={`collapsible-tab ${isActiveCls} ${className} ${noScrollCls}`}
      onClick={onTabClick.bind(null, value)}
      key={value}
    >
      <div className="tab-selector" style={{ color: color }}>
        <div className="label">{label}</div>
        <div className="count">{count}</div>
        <MdKeyboardArrowUp className="arrow-icon" size="1.2em" />
      </div>
      <Collapse className="tab-content-collapse" in={active}>
        <div className="tab-content">
          {noScroll ? (
            content
          ) : (
            <Scrollbars className="tabs-scroll">{content}</Scrollbars>
          )}
        </div>
      </Collapse>
    </div>
  );
};
function CollapsibleTabs(props) {
  const {
    tabs,
    className,
    onChange,
    noScroll,
    useDefaultTheme,
    ...rest
  } = props;
  const defaultThemeCls = useDefaultTheme ? "default" : "";
  return (
    <div
      className={`collapsible-tabs-ctr ${defaultThemeCls} ${className}`}
      {...rest}
    >
      {tabs.map((tab) => renderTab({ ...tab, onChange, noScroll }))}
    </div>
  );
}

CollapsibleTabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      content: PropTypes.any,
      label: PropTypes.string,
      count: PropTypes.number,
      color: PropTypes.string,
      active: PropTypes.bool,
      className: PropTypes.string,
    })
  ),
  noScroll: PropTypes.bool,
  useDefaultTheme: PropTypes.bool,
};

CollapsibleTabs.defaultProps = {
  className: "",
  tabs: [],
  onChange: () => {},
  noScroll: false,
  useDefaultTheme: false,
};

export default CollapsibleTabs;
